import { getLibraryReferenceBaseId, getLibraryReferenceIds } from './libraryReferenceMapping';

/** Legacy course queries stay exact; standard-library queries may read their confirmed singular aliases. */
export function matchesLibraryHistoryExercise(storedId: string, queryId: string): boolean {
  if (!queryId.startsWith('library-')) return storedId === queryId;
  const targets = getLibraryReferenceIds(storedId);
  // A legacy superset's single recorded weight cannot be attributed to both component movements.
  return targets.length === 1 && targets[0] === getLibraryReferenceBaseId(queryId);
}

export function findCompatibleLibraryPR<T extends { exerciseId: string; maxWeight: number; maxReps: number }>(
  records: T[], queryId: string,
): T | undefined {
  if (!queryId.startsWith('library-')) return records.find(record => record.exerciseId === queryId);
  return records.filter(record => matchesLibraryHistoryExercise(record.exerciseId, queryId))
    .reduce<T | undefined>((best, record) => !best || record.maxWeight > best.maxWeight ||
      (record.maxWeight === best.maxWeight && record.maxReps > best.maxReps) ? record : best, undefined);
}

/** A transient query view preserves raw records and their original names, IDs and set measurements. */
export function recordsForLibraryHistoryQuery<T extends { exercises: { exerciseId: string }[] }>(
  records: T[], queryId: string,
): T[] {
  if (!queryId.startsWith('library-')) return records;
  return records.map(record => ({ ...record, exercises: record.exercises.map(exercise =>
    matchesLibraryHistoryExercise(exercise.exerciseId, queryId) ? { ...exercise, exerciseId: queryId } : exercise) }));
}
